import Vue from 'vue'   //引入Vue
import VueRouter from "vue-router";  //引入vue-router

Vue.use(VueRouter)  //Vue全局使用Router

let routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/pages/Home/index.vue'),
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/pages/Home/index.vue')
    },
    {
        path: '/people',
        name: 'People',
        component: () => import('@/pages/People/index.vue')
    },
    {
        path: '/publications',
        name: 'Publications',
        component: () => import('@/pages/Publications/index.vue')
    },
    {
        path: '/resources',
        name: 'Resources',
        component: () => import('@/pages/Resources/index.vue')
    },
    // {
    //     path: '/activities',
    //     name: 'Activities',
    //     component: () => import('@/pages/Activities/index.vue')
    // },
    {
        path: '/labnews',
        name: 'LabNews',
        component: () => import('@/pages/LabNews/index.vue')
    },
    {
        path: '/joinUs',
        name: 'JoinUs',
        component: () => import('@/pages/JoinUs/index.vue')
    },
]

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => err);
};
var router = new VueRouter({
    mode: "history",
    routes: routes,
    scrollBehavior() {
        // 返回到顶部
        return {x: 0, y: 0};
    }
})

export default router;
